import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 24 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 17\" id=\"icon-email\">\n    <g stroke=\"currentColor\" fill=\"none\" fill-rule=\"evenodd\">\n        <rect x=\".5\" y=\".5\" width=\"23\" height=\"16\" rx=\"2\" />\n        <path d=\"M.526 1.72L12 8.045 23.474 1.72A1.5 1.5 0 0 0 22 .5H2A1.5 1.5 0 0 0 .526 1.72z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol